module.exports = __webpack_public_path__ + "img/parter-logo-4.fab14033.png";